import { render, staticRenderFns } from "./FindNearbyClinics.vue?vue&type=template&id=2a271ec6&"
import script from "./FindNearbyClinics.vue?vue&type=script&lang=js&"
export * from "./FindNearbyClinics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports